import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-top-bar"
}
const _hoisted_2 = { class: "left-title-box" }
const _hoisted_3 = { class: "main-title" }
const _hoisted_4 = {
  key: 0,
  class: "selected-category-title"
}
const _hoisted_5 = {
  key: 0,
  class: "left-box"
}
const _hoisted_6 = { class: "single-select-box" }
const _hoisted_7 = {
  key: 0,
  class: "reset-button"
}
const _hoisted_8 = {
  key: 1,
  class: "right-box"
}
const _hoisted_9 = { class: "select-all-box" }
const _hoisted_10 = { class: "types-select-box" }

import { ref, computed, onBeforeUnmount, watch } from 'vue'
import { useStore } from 'vuex'
import ListMenuHeader from '@/components/general/lists/ListMenuWithCheckbox/ListMenuHeader.vue'
import ListCategory from '@/components/general/lists/ListMenuWithCheckbox/ListCategory.vue'
import ListTypeItems from '@/components/general/lists/ListMenuWithCheckbox/ListTypeItems.vue'
import SelectAllCheckbox from '@/components/general/lists/ListMenuWithCheckbox/SelectAllCheckbox.vue'
import { orderAlphabetical } from '@/utils/sort'
import { useGeneralStore } from '@/pinia'

export interface CategoryItem {
  id: string
  name: string
  types: TypeItem[]
  visible: boolean
}
export interface TypeItem {
  id: string
  color: string
  name: string
  disabled: boolean
  visible: boolean
}
interface EMITS {
  (e: 'onChecklistToggle', typeId: any, categoryId: any, checked: boolean)
  (e: 'closedOverlay')
  (e: 'onHoverListMenu')
  (e: 'closeHoverListMenu')
}
interface PROPS {
  delay?: string // Used for multiselect delay, value as string in ms
  title: string
  categories: CategoryItem[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ListMenuWithCheckbox',
  props: {
    delay: {},
    title: {},
    categories: {}
  },
  emits: ["onChecklistToggle", "closedOverlay", "onHoverListMenu", "closeHoverListMenu"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const store = useStore()
const piniaStore = useGeneralStore()
const selectedCategory = ref<CategoryItem | undefined>(undefined)
const allCategoryTypesSelected = computed(
  () => selectedCategory.value?.types?.every((type) => type.visible) ?? false
)

const mobileScreen = computed<string>(() => store.state.mobileScreen)
const currentMobileView = ref<'LEFT' | 'RIGHT'>('LEFT')
const currentView = computed<'ALL' | 'LEFT' | 'RIGHT'>(() => {
  if (mobileScreen.value) {
    return currentMobileView.value
  } else {
    return 'ALL'
  }
})

onBeforeUnmount(() => {
  store.commit('SET_SHOW_ZONE_MENU', false)
  store.commit('SET_POI_MENU', false)
  piniaStore.setShowLineMenu(false)
})

function closeOverlay() {
  store.commit('SET_SHOW_ZONE_MENU', false)
  store.commit('SET_POI_MENU', false)
  piniaStore.setShowLineMenu(false)
}

function emitId(typeId, event) {
  emits('onChecklistToggle', typeId, selectedCategory.value?.id, event)
}

function goBack() {
  currentMobileView.value = 'LEFT'
}

function hideMenu() {
  emits('closeHoverListMenu')
}

async function markAllTypes(allSelected: boolean) {
  if (!selectedCategory.value) return
  for (let type of selectedCategory.value.types) {
    if (props.delay) {
      const delayInteger = parseInt(props.delay)
      await new Promise((resolve) => setTimeout(resolve, delayInteger)) // Currently (for example) line sources generated in Pinia store have to be loaded with a delay to not be overwritten
    }
    emits('onChecklistToggle', type.id, selectedCategory.value.id, allSelected)
  }
}

function onSelectCategory(categoryId: string) {
  selectedCategory.value = props.categories.find((category) => category.id === categoryId)!!
  currentMobileView.value = 'RIGHT'
  selectedCategory.value.types.sort(orderAlphabetical)
}

function resetAll() {
  for (let category of props.categories) {
    for (let type of category.types) {
      if (type.visible === true) {
        emits('onChecklistToggle', type.id, category.id, false)
      }
    }
  }
}

function showMenu() {
  if (!mobileScreen.value) emits('onHoverListMenu')
}

watch(
  () => props.categories,
  (newVal, oldVal) => {
    if (!oldVal?.length && newVal.length) selectedCategory.value = props.categories[0]
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: "#home",
    disabled: !mobileScreen.value
  }, [
    (selectedCategory.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "main-body",
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (showMenu())),
          onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (hideMenu()))
        }, [
          (mobileScreen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ListMenuHeader, {
                  leftBox: currentView.value == 'LEFT',
                  onCloseOverlay: closeOverlay,
                  onResetAll: resetAll,
                  onGoBack: goBack
                }, null, 8, ["leftBox"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(_ctx.title), 1),
              (currentView.value == 'RIGHT')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(selectedCategory.value?.name ?? ''), 1))
                : _createCommentVNode("", true)
            ]),
            (currentView.value == 'LEFT' || currentView.value == 'ALL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(ListCategory, {
                      categories: _ctx.categories,
                      selectedCategoryId: selectedCategory.value?.id ?? '',
                      onOnSelectCategory: onSelectCategory
                    }, null, 8, ["categories", "selectedCategoryId"]),
                    (!mobileScreen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("button", {
                            class: "reset-button-style",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (resetAll()))
                          }, _toDisplayString(_ctx.$t('general__data__reset-all-choices')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (currentView.value == 'RIGHT' || currentView.value == 'ALL')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(SelectAllCheckbox, {
                    selectAll: allCategoryTypesSelected.value,
                    onSelectAll: markAllTypes
                  }, null, 8, ["selectAll"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(ListTypeItems, {
                    typeItems: selectedCategory.value?.types ?? [],
                    onEmitId: emitId
                  }, null, 8, ["typeItems"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 32))
      : _createCommentVNode("", true)
  ], 8, ["disabled"]))
}
}

})